/*
 * PayPal headless checkout constants (KINDW-276).
 * Shared by checkout hooks/utils and server PayPal services.
 */

/** Checkout routes (relative paths). */
export const PAYPAL_CHECKOUT_ROUTES = Object.freeze({
  BILLING: '/checkout/billing',
  BILLING_CANCELLED: '/checkout/billing?status=cancelled',
  CHECKOUT: '/checkout',
  PAYMENT_PROCESSING: '/checkout/payment-processing',
});

export const PAYPAL_DEFAULT_RETURN_PATH = PAYPAL_CHECKOUT_ROUTES.PAYMENT_PROCESSING;

export const PAYPAL_DEFAULT_CANCEL_PATH = PAYPAL_CHECKOUT_ROUTES.BILLING_CANCELLED;

/** Paths allowed when building PayPal return/cancel URLs (server sanitization). */
export const PAYPAL_ALLOWED_RETURN_PATHS = Object.freeze([
  PAYPAL_CHECKOUT_ROUTES.PAYMENT_PROCESSING
]);

export const PAYPAL_ALLOWED_CANCEL_PATHS = Object.freeze([
  PAYPAL_CHECKOUT_ROUTES.BILLING,
  PAYPAL_CHECKOUT_ROUTES.BILLING_CANCELLED
]);

/** MRT Express routes. */
export const PAYPAL_SERVER_ROUTES = Object.freeze({
  BASE: '/server/paypal',
  CANCEL: '/server/paypal/cancel',
  CREATE: '/server/paypal/create',
  FAILURE: '/server/paypal/failure',
});

/**
 * PayPal REST API paths (relative to `PAYPAL_API_BASE_URL`).
 * @see https://developer.paypal.com/docs/api/orders/v2/#orders_capture
 */
export const PAYPAL_REST_PATHS = Object.freeze({
  CHECKOUT_ORDERS: '/v2/checkout/orders',
  OAUTH_TOKEN: '/v1/oauth2/token',
});

export const PAYPAL_REST = Object.freeze({
  APPROVE_LINK_RELS: Object.freeze(['payer-action', 'approve']),
  APPROVE_URL_HOST_PATTERN: /paypal\.com/i,
  APPROVE_URL_SCHEME: 'https://',
  OAUTH_GRANT_TYPE: 'client_credentials',
  ORDER_INTENT_CAPTURE: 'CAPTURE',
  ORDER_USER_ACTION_PAY_NOW: 'PAY_NOW',
});

export const PAYPAL_PAYMENT_METHOD_ID = 'PayPal';

/** SCAPI payment instrument custom attribute (matches SFCC metadata). */
export const PAYPAL_PI_ATTR_ORDER_ID = 'c_paypalOrderID';

export const PAYPAL_CHECKOUT_STATUS = Object.freeze({
  CANCELLED: 'cancelled',
  ERROR: 'paypal_error',
});

export const PAYPAL_URL_QUERY = Object.freeze({
  CODE: 'code',
  STATUS: 'status',
  TOKEN: 'token',
});

export const PAYPAL_SESSION_KEYS = Object.freeze({
  CHECKOUT_STATUS: 'king_paypal_checkout_status',
  FLOW_BASKET_ID: 'king_paypal_flow_basket_id',
  FLOW_SNAPSHOT: 'king_paypal_flow_snapshot',
  FLOW_STARTED_AT: 'king_paypal_flow_started_at',
  STATUS_HANDLED_PREFIX: 'king_paypal_status_handled',
});

/** Max time shopper may stay on PayPal before return is treated as expired. */
export const PAYPAL_APPROVAL_MAX_MS = 15 * 60 * 1000;

export const PAYPAL_TOKEN_PATTERN = /^[A-Za-z0-9_-]{10,127}$/;

export const PAYPAL_ERROR_CODE_PATTERN = /^[A-Za-z0-9_.-]{1,64}$/;
